/**
 * @prop --cbp-table-color: var(--cbp-color-text-darkest);
 * @prop --cbp-table-color-dark: var(--cbp-color-text-lightest);
   
 * @prop --cbp-table-header-color: var(--cbp-color-interactive-secondary-darker);
 * @prop --cbp-table-header-color-dark: var(--cbp-color-interactive-secondary-lighter);
 * @prop --cbp-table-header-color-hover: var(--cbp-color-interactive-secondary-lighter);
 * @prop --cbp-table-header-color-hover-dark: var(--cbp-color-interactive-secondary-darker);
 * @prop --cbp-table-header-color-focus: var(--cbp-color-text-lightest);
 * @prop --cbp-table-header-color-focus-dark: var(--cbp-color-text-darkest);
 * @prop --cbp-table-header-color-active: var(--cbp-color-text-darkest);
 * @prop --cbp-table-header-color-active-dark: var(--cbp-color-text-darkest);

 * @prop --cbp-table-header-color-bg: var(--cbp-color-gray-cool-20);
 * @prop --cbp-table-header-color-bg-dark: var(--cbp-color-gray-cool-60);
 * @prop --cbp-table-header-color-bg-hover: var(--cbp-color-interactive-secondary-darker);
 * @prop --cbp-table-header-color-bg-hover-dark: var(--cbp-color-interactive-secondary-lighter);
 * @prop --cbp-table-header-color-bg-focus: var(--cbp-color-interactive-focus-dark);
 * @prop --cbp-table-header-color-bg-focus-dark: var(--cbp-color-interactive-focus-light);
 * @prop --cbp-table-header-color-bg-active: var(--cbp-color-interactive-active-dark);
 * @prop --cbp-table-header-color-bg-active-dark: var(--cbp-color-interactive-active-light);

 * @prop --cbp-table-header-color-outline: var(--cbp-color-white);
 * @prop --cbp-table-header-color-outline-dark: var(--cbp-color-black);

 * @prop --cbp-table-row-color-bg: var(--cbp-color-white);
 * @prop --cbp-table-row-color-bg-dark: var(--cbp-color-gray-cool-70);
 * @prop --cbp-table-row-color-bg-striped: var(--cbp-color-gray-cool-4);
 * @prop --cbp-table-row-color-bg-striped-dark: var(--cbp-color-gray-cool-80);
 * @prop --cbp-table-row-color-bg-hover: var(--cbp-color-gray-cool-10);
 * @prop --cbp-table-row-color-bg-hover-dark: var(--cbp-color-gray-cool-90);
 * @prop --cbp-table-row-color-bg-selected: var(--cbp-color-interactive-selected-light);
 * @prop --cbp-table-row-color-bg-selected-dark: var(--cbp-color-interactive-selected-dark);
 * @prop --cbp-table-color-bg-danger: var(--cbp-color-danger-lighter);
 * @prop --cbp-table-color-bg-danger-dark: var(--cbp-color-danger-darker);
 * @prop --cbp-table-row-color-bg-highlight: var(--cbp-color-highlight);
 
 * @prop --cbp-table-row-color-border: var(--cbp-color-gray-cool-30);
 * @prop --cbp-table-row-color-border-dark: var(--cbp-color-gray-cool-50);
 * @prop --cbp-table-row-border-size: var(--cbp-border-size-md); 

 * @prop --cbp-table-cell-padding: var(--cbp-space-4x) var(--cbp-space-3x);
 * @prop --cbp-table-linearized-cell-padding: var(--cbp-space-2x) var(--cbp-space-3x);
 */

:root {
  --cbp-table-color: var(--cbp-color-text-darkest);
  --cbp-table-color-dark: var(--cbp-color-text-lightest);

  --cbp-table-header-color: var(--cbp-color-interactive-secondary-darker);
  --cbp-table-header-color-dark: var(--cbp-color-interactive-secondary-lighter);
  --cbp-table-header-color-hover: var(--cbp-color-interactive-secondary-lighter);
  --cbp-table-header-color-hover-dark: var(--cbp-color-interactive-secondary-darker);
  --cbp-table-header-color-focus: var(--cbp-color-text-lightest);
  --cbp-table-header-color-focus-dark: var(--cbp-color-text-darkest);
  --cbp-table-header-color-active: var(--cbp-color-text-darkest);
  --cbp-table-header-color-active-dark: var(--cbp-color-text-darkest);

  --cbp-table-header-color-bg: var(--cbp-color-gray-cool-20);
  --cbp-table-header-color-bg-dark: var(--cbp-color-gray-cool-60);
  --cbp-table-header-color-bg-hover: var(--cbp-color-interactive-secondary-darker);
  --cbp-table-header-color-bg-hover-dark: var(--cbp-color-interactive-secondary-lighter);
  --cbp-table-header-color-bg-focus: var(--cbp-color-interactive-focus-dark);
  --cbp-table-header-color-bg-focus-dark: var(--cbp-color-interactive-focus-light);
  --cbp-table-header-color-bg-active: var(--cbp-color-interactive-active-dark);
  --cbp-table-header-color-bg-active-dark: var(--cbp-color-interactive-active-light);

  --cbp-table-header-color-outline: var(--cbp-color-white);
  --cbp-table-header-color-outline-dark: var(--cbp-color-black);

  --cbp-table-row-color-bg: var(--cbp-color-white);
  --cbp-table-row-color-bg-dark: var(--cbp-color-gray-cool-70);
  --cbp-table-row-color-bg-striped: var(--cbp-color-gray-cool-4);
  --cbp-table-row-color-bg-striped-dark: var(--cbp-color-gray-cool-80);
  --cbp-table-row-color-bg-hover: var(--cbp-color-gray-cool-10);
  --cbp-table-row-color-bg-hover-dark: var(--cbp-color-gray-cool-90);
  --cbp-table-row-color-bg-selected: var(--cbp-color-interactive-selected-light);
  --cbp-table-row-color-bg-selected-dark: var(--cbp-color-interactive-selected-dark);
  --cbp-table-color-bg-danger: var(--cbp-color-danger-lighter);
  --cbp-table-color-bg-danger-dark: var(--cbp-color-danger-darker);
  --cbp-table-row-color-bg-highlight: var(--cbp-color-highlight);

  --cbp-table-row-color-border: var(--cbp-color-gray-cool-30);
  --cbp-table-row-color-border-dark: var(--cbp-color-gray-cool-50);
  --cbp-table-row-border-size: var(--cbp-border-size-md); 

  --cbp-table-cell-padding: var(--cbp-space-4x) var(--cbp-space-3x);
  --cbp-table-linearized-cell-padding: var(--cbp-space-2x) var(--cbp-space-3x);
}

/* 
 * Dark Mode - display dark design based on mode or context
 */
 [data-cbp-theme=light] cbp-table[context*=dark],
 [data-cbp-theme=dark] cbp-table:not([context=dark-inverts]):not([context=light-always]) {
  --cbp-table-color: var(--cbp-table-color-dark) !important;
  
  --cbp-table-header-color: var(--cbp-table-header-color-dark) !important;
  --cbp-table-header-color-hover: var(--cbp-table-header-color-hover-dark) !important;
  --cbp-table-header-color-focus: var(--cbp-table-header-color-focus-dark) !important;
  --cbp-table-header-color-active: var(--cbp-table-header-color-active-dark) !important;
  --cbp-table-header-color-bg: var(--cbp-table-header-color-bg-dark) !important;
  --cbp-table-header-color-bg-hover: var(--cbp-table-header-color-bg-hover-dark) !important;
  --cbp-table-header-color-bg-focus: var(--cbp-table-header-color-bg-focus-dark) !important;
  --cbp-table-header-color-bg-active: var(--cbp-table-header-color-bg-active-dark) !important;
  --cbp-table-header-color-outline: var(--cbp-table-header-color-outline-dark) !important;

  --cbp-table-row-color-bg: var(--cbp-table-row-color-bg-dark) !important;
  --cbp-table-row-color-bg-striped: var(--cbp-table-row-color-bg-striped-dark) !important;
  --cbp-table-row-color-bg-hover: var(--cbp-table-row-color-bg-hover-dark) !important;
  --cbp-table-row-color-bg-selected: var(--cbp-table-row-color-bg-selected-dark) !important;
  --cbp-table-color-bg-danger: var(--cbp-table-color-bg-danger-dark) !important;

  --cbp-table-row-color-border: var(--cbp-table-row-color-border-dark) !important;
}

cbp-table {
  display: block;
  max-width: 100%;

  .cbp-table-toolbar {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: var(--cbp-space-2x);
    width: 100%;
    margin-block-end: var(--cbp-space-2x);
  }

  .cbp-table-toolbar-scroll {
    display: none;
    flex-grow: 1;
    text-align: end;
  }

  // Responsive horizontally scrolling table
  &.cbp-table-scroll {
    .cbp-table-toolbar-scroll {
      --cbp-button-border-radius: 0;
      display: block;
    }

    .cbp-table-wrapper {
      position: relative;
      overflow-x: scroll;
      // Gradient mask for visual affordance of additional content
      mask: linear-gradient(to right,#0003,#ffff var(--left-fade) calc(100% - var(--right-fade)), #0003);
      animation: scrollfade;
      animation-timeline: --scrollfade;
      scroll-timeline: --scrollfade x;
    }

    // When a row header is used, make it sticky when scrolling overflow
    table:has(tbody th:first-child) th:first-child {
      position: sticky;
      left: 0;
      inset-inline-start: 0;
    }
  }
  
  // Responsive linearized table
  &.cbp-table-linearize {
    thead {
      display: none;
    }
    td,th {
      display: block;
      padding: var(--cbp-table-linearized-cell-padding);
    }
    tbody td:not(:has(cbp-checkbox))::before {
      content: attr(data-column-header);
      font-weight: var(--cbp-font-weight-medium);
    }
  }
  

  // General classes for danger and highlighting (selected rows overrides, however)
  //added ".cbp-table-wrapper table tbody tr" selectors to up specificity so danger/highlight override the striped styling
  .cbp-table-wrapper table tbody tr {
    &.cbp-table--danger td,
    &.cbp-table--danger th,
    td.cbp-table--danger,
    th.cbp-table--danger {
      background-color: var(--cbp-table-color-bg-danger);
    }

    &.cbp-table--highlight td,
    &.cbp-table--highlight th,
    td.cbp-table--highlight,
    th.cbp-table--highlight {
      color: var(--cbp-color-text-darkest);
      background-color: var(--cbp-table-row-color-bg-highlight);
    }
  }
  // Striped rows
  &[striped=odd] {
    tbody {
      tr:nth-child(odd) {
        td, th{
            background-color: var(--cbp-table-row-color-bg-striped);
          } 
        }
    }
  }

  &[striped=even] {
    tbody {
      tr:nth-child(even) {
        td, th{
          background-color: var(--cbp-table-row-color-bg-striped);    
        }
      }
    }
  }

  // Row hover effect
  &[hover=row] {
    tbody {
      tr:hover {
        th, td {
          background-color: var(--cbp-table-row-color-bg-hover);
        }
        
        td.cbp-table--highlight,
        &.cbp-table--highlight td {
          color: var(--cbp-color-text-darkest);
          background-color: var(--cbp-table-row-color-bg-highlight);
        }
      }
    }
  }

  // Cell hover effect
  //".cbp-table-wrapper table tbody tr" selectors to up specificity so hover override the striped styling
  &[hover=cell] {
    .cbp-table-wrapper table tbody tr {
      th:hover,
      td:hover{
          background-color: var(--cbp-table-row-color-bg-hover);
        
        &.cbp-table--highlight{
          color: var(--cbp-color-text-darkest);
          background-color: var(--cbp-table-row-color-bg-highlight);
        }
      }
    }
  }

  
  // Column highlighting on hover (except for column header when sortable; updated to work with multi-row headers using the bottom row)
  // TechDebt: doesn't scale; this would be better, but still experimental: https://developer.mozilla.org/en-US/docs/Web/CSS/Column_combinator#browser_compatibility
  &[column-hover] {
    table thead tr:last-child th:hover,
    table:has(thead tr:last-child > *:nth-child(1):hover) tbody tr > *:nth-child(1),
    table:has(thead tr:last-child > *:nth-child(2):hover) tbody tr > *:nth-child(2),
    table:has(thead tr:last-child > *:nth-child(3):hover) tbody tr > *:nth-child(3),
    table:has(thead tr:last-child > *:nth-child(4):hover) tbody tr > *:nth-child(4),
    table:has(thead tr:last-child > *:nth-child(5):hover) tbody tr > *:nth-child(5),
    table:has(thead tr:last-child > *:nth-child(6):hover) tbody tr > *:nth-child(6),
    table:has(thead tr:last-child > *:nth-child(7):hover) tbody tr > *:nth-child(7),
    table:has(thead tr:last-child > *:nth-child(8):hover) tbody tr > *:nth-child(8),
    table:has(thead tr:last-child > *:nth-child(9):hover) tbody tr > *:nth-child(9),
    table:has(thead tr:last-child > *:nth-child(10):hover) tbody tr > *:nth-child(10) {
      &:not([aria-sort]) {
        color: var(--cbp-table-color);
        background-color: var(--cbp-table-row-color-bg-hover);
      }
    }
  }

  table {
    margin: 0;
    padding: 0;
    max-width: 100%;
    text-align: left;
    border-collapse: collapse;

    caption {
      text-align: start;
      font-size: var(--cbp-font-size-heading-xl);
      line-height: var(--cbp-line-height-xl);
    }

    th, td {
      color: var(--cbp-table-color);
      vertical-align: top;
      padding: var(--cbp-table-cell-padding);

      // TechDebt: may need to do these sorts of overrides for additional components inside of tables and reevaluate where the selectors belong.
      &:has(input[type=checkbox]) {
        vertical-align: middle;
        padding-block: var(--cbp-space-2x);
      }

      cbp-checkbox {
        --cbp-checkbox-min-height: 0;
        --cbp-checkbox-margin: 0;
      }
    }

    thead {
      th {
        font-size: var(--cbp-font-size-heading-xs);
        vertical-align: bottom;
        transition: width 2s; // a long transition prevents jumpiness when clicking sortable controls
        --cbp-button-color: var(--cbp-table-header-color);
        --cbp-button-color-dark: var(--cbp-table-header-color-dark);
        color: var(--cbp-table-header-color);
        background-color: var(--cbp-table-header-color-bg);
        font-weight: var(--cbp-font-weight-medium);
        text-wrap: balance;
        outline-width: 0;
        outline-style: solid;
        outline-color: var(--cbp-table-header-color-outline);
        outline-offset: calc(var(--cbp-space-1x) * -1);

        &[aria-sort=none] button {
          // Use padding as a placeholder to keep columns from shifting when sorted and an icon is added.
          padding-inline-end: var(--cbp-space-9x); // icon = 4x + gap = 2x + end padding = 3x = 9x
        }

        &:has(button) {
          padding: 0;
        }

        &:has(button:hover) {
          --cbp-table-header-color: var(--cbp-table-header-color-hover);
          --cbp-table-header-color-bg: var(--cbp-table-header-color-bg-hover);
          --cbp-table-header-color-dark: var(--cbp-table-header-color-hover-dark);
          --cbp-table-header-color-bg-dark: var(--cbp-table-header-color-bg-hover-dark);
          
          cbp-button[fill][color] {
            --cbp-button-color-hover: var(--cbp-table-header-color-hover);
            --cbp-button-color-hover-dark: var(--cbp-table-header-color-hover-dark);
          }
        }

        &:has(cbp-button[fill][color] button:focus) {
          --cbp-table-header-color: var(--cbp-table-header-color-focus);
          --cbp-table-header-color-bg: var(--cbp-table-header-color-bg-focus);
          --cbp-table-header-color-dark: var(--cbp-table-header-color-focus-dark);
          --cbp-table-header-color-bg-dark: var(--cbp-table-header-color-bg-focus-dark);
          outline-width: var(--cbp-border-size-md);
        }

        &:has(cbp-button[fill][color] button:active) {
          --cbp-table-header-color: var(--cbp-table-header-color-active);
          --cbp-table-header-color-bg: var(--cbp-table-header-color-bg-active);
          --cbp-table-header-color-dark: var(--cbp-table-header-color-active-dark);
          --cbp-table-header-color-bg-dark: var(--cbp-table-header-color-bg-active-dark);
        }

        cbp-button {
          // Reset button styles to be invisible and style the TH like a button due to button height issues.
          --cbp-button-border-radius: 0;
          --cbp-button-border-width: 0;
          --cbp-button-focus-outline-width: 0;
          --cbp-button-color-bg: transparent !important;
          --cbp-button-color-bg-hover: transparent !important;
          --cbp-button-color-bg-focus: transparent !important;
          --cbp-button-color-bg-active: transparent !important;
          --cbp-button-color-bg-dark: transparent !important;
          --cbp-button-color-bg-hover-dark: transparent !important;
          --cbp-button-color-bg-focus-dark: transparent !important;
          --cbp-button-color-bg-active-dark: transparent !important;
          --cbp-button-padding: var(--cbp-table-cell-padding);

          button {
            justify-content: flex-start;
            text-align: left;
            text-transform: unset;
            letter-spacing: unset;
            white-space: normal;
            text-wrap: balance;
            margin: 0;
            transition: width 2s; // a long transition prevents jumpiness when clicking sortable controls
          }
        }
      }

      th:has(button:hover) {
        --cbp-button-color-bg-hover: transparent !important;
        --cbp-button-color-bg-hover-dark: transparent !important;
      }

      th:has(button:focus) {
        --cbp-button-color-bg-focus: var(--cbp-color-interactive-focus-dark) !important;
        --cbp-button-color-bg-focus-dark: var(--cbp-color-interactive-focus-light) !important;
      }
    }


    tbody {
      tr {
        td, th{
          background-color: var(--cbp-table-row-color-bg);
        }
        
        // Selected state should override all others (striping, danger, highlight)
        &:has(input[type=checkbox]:checked){
          td,
          th {
            color: var(--cbp-table-color);
            background-color: var(--cbp-table-row-color-bg-selected);
          }
        }
      }

      td:has(cbp-button){
        padding-block: 0;
        vertical-align: middle;
      }
    }

    tr {
      border-bottom: solid var(--cbp-table-row-border-size) var(--cbp-table-row-color-border);
    }

    th {
      font-weight: var(--cbp-font-weight-medium);

      &[colspan]{
        text-align: center;
        
        &:not(:last-child){
        border-right: solid var(--cbp-table-row-border-size) var(--cbp-table-row-color-border);
      }
      }
    }

    td {
      text-wrap: pretty;
    }
  }
  
  &:not(.cbp-table-linearize ) table th[scope="row"]{
    border-right: solid var(--cbp-table-row-border-size) var(--cbp-table-row-color-border);
  } 
}

// Shows a gradient mask on the table for either direction that has overflowed content
@property --left-fade {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}

@property --right-fade {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}

@keyframes scrollfade {
  0% {
    --left-fade: 0;
  }
  10%, 100% {
    --left-fade: 1rem;
  }
  0%, 90% {
    --right-fade: 1rem;
  }
  100% {
    --right-fade: 0;
  }
}